import { withVersions } from "v2/hocs/withVersions";
import ScrollableEmptyUIV1 from "./ScrollableEmpty/v1";
import ScrollableLoadingUIV1 from "./ScrollableLoading/v1";
import ScrollableLoadMoreUIV1 from "./ScrollableLoadMore/v1";
import ScrollableWrapperUIV1 from "./ScrollableWrapper/v1";
import { withScrollable } from "../hocs/withScrollable";

const ScrollableUI = {
  Empty: withVersions({
    v1: ScrollableEmptyUIV1,
    v2: ScrollableEmptyUIV1,
  }),
  Loading: withVersions({
    v1: ScrollableLoadingUIV1,
    v2: ScrollableLoadingUIV1,
  }),
  LoadMore: withVersions({
    v1: ScrollableLoadMoreUIV1,
    v2: ScrollableLoadMoreUIV1,
  }),
  Wrapper: withVersions({
    v1: ScrollableWrapperUIV1,
    v2: ScrollableWrapperUIV1,
  }),
};

const Scrollable = withScrollable(
  ScrollableUI.Wrapper,
  ScrollableUI.Loading,
  ScrollableUI.Empty,
  ScrollableUI.LoadMore,
);

export default Scrollable;
